export default {
  "promoter": {
    "partnerId": 3440
  },
  "siteDomain": "https://mixer-hybrid.magazineluiza.com.br",
  "logLevel": "error",
  "environment": "production",
  "cookieDomain": ".magazineluiza.com.br",
  "isMiniApp": false,
  "datasource": {
    "graphql": {
      "host": "https://federation.magazineluiza.com.br",
      "timeout": 5000
    }
  },
  "channel": {
    "ios": {
      "id": "54",
      "name": "supper-app-ios"
    },
    "android": {
      "id": "53",
      "name": "supper-app-android"
    }
  },
  "ads": {
    "host": "https://securepubads.g.doubleclick.net/gampad/adx",
    "timeout": 5000
  },
  "cart": {
    "host": "https://sacolamobile.magazineluiza.com.br"
  },
  "magaluads": {
    "host": "https://ads-query.luizalabs.com"
  },
  "shipping": {
    "timeout": 5000
  },
  "report": {
    "host": "https://luizalabs-prod.apigee.net/v1/product/report/",
    "mail": "someone@luizalabs.com"
  },
  "review": {
    "mediaApi": "https://eufrazino-media-api.mglu.io",
    "timeout": 8000
  }
}
